import { defineComponent as _defineComponent } from 'vue'
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DataNotice',
  props: {
    text: null,
    fontSize: { default: '12px' },
    lineHeight: { default: '16px' }
  },
  setup(__props: any) {



return { __sfc: true,BCXMarkdown }
}

})